import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Store, select } from "@ngrx/store";
import { AppState } from "../../../app.state";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { IModoEntrada } from "../../../interfaces/catalogos.";
import { LoadingService } from "../../../loading/loading.service";
import { ModoEntradaService } from "../../../services/catalogos/modo-entrada/modo-entrada.service";
import { showHideCatalogo } from "../../../states/admon-catalogos/actions";
import { selectCatalogoModoStatus } from "../../../states/admon-catalogos/selector";
import { cargaModoEntrada } from "../../../states/catalogos/actions";
import {
  campoRequerido,
  descripcionCatalogo,
  existeValorDuplicado
} from "../../utils";
import { AddModoEntradaComponent } from "../add-edit/add-edit.component";

@Component({
  selector: "app-list",
  standalone: true,
  imports: [
    AddModoEntradaComponent,
    MatCardModule,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./list.component.html",
  styleUrl: "./list.component.css",
})
export class ListModoEntradaComponent {
  modoEntradas: IModoEntrada[] = [];
  registroSeleccionado!: IModoEntrada | null;
  ocultarVistaLectura = false;
  editandoRegistro = false;
  mostrarBotones = true;
  existe = false;
  editarForm!: FormGroup;
  private store: Store<AppState> = inject(Store);
  admonCatModoStatus$ = this.store.pipe(select(selectCatalogoModoStatus));

  constructor(
    private modoEntradaService: ModoEntradaService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    public loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.loadingService.show();
    this.editarForm = this.fb.group({
      descripcion: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          descripcionCatalogo(),
          campoRequerido(),
        ],
      ],
    });

    this.modoEntradaService.cargarModoEntrada().subscribe(
      (response) => {
        this.modoEntradas = response;
        console.log("Modo Entrada cargadas:", this.modoEntradas);
        this.loadingService.hide();
        // Realizar otras acciones después de cargar las empresas
        console.log("Cargamos empresas en app store");
        this.store.dispatch(cargaModoEntrada({ catModoEntrada: response }));
      },
      (error) => {
        this.loadingService.hide();
        console.error("Error al cargar empresas:", error);
        // Manejar el error de carga de empresas
      }
    );
  }

  editarRegistro(modoEntrada: IModoEntrada | null): void {
    this.registroSeleccionado = modoEntrada;
    this.editandoRegistro = true;
    this.editarForm.setValue({
      descripcion: modoEntrada?.descripcion || "",
    });
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "modosEntrada",
        mostrarEditar: true,
        mostrarNuevo: false,
        guardando: false,
      })
    );
  }

  cancelarEdicion() {
    this.editandoRegistro = false;
    this.editarForm.setValue({
      descripcion: "",
    });
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "modosEntrada",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );
  }

  ocultarBotones(value: boolean) {
    console.log("value ", value);

    this.mostrarBotones = value;
    this.editandoRegistro = value;
    this.registroSeleccionado = null;
  }

  guardarCambios(data: IModoEntrada) {
    console.log("");
    console.log("Comentario guardado:", this.editarForm.value.descripcion);

    if (this.editarForm.valid) {
      this.modoEntradaService
        .editarModo({
          ...data,
          descripcion: this.editarForm.value.descripcion,
        })
        .subscribe((data) => {
          if (!data.error) {
            this.cancelarEdicion();
          }
          this.loadingService.hide();
        });
    }
  }
  eliminarEmpresa(modoEntrada: IModoEntrada): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title: "Advertencia",
        message: "¿Estás seguro que quieres eliminar el elemento?",
        showButtons: {
          accept: true,
          cancel: true,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "CONFIRMAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      this.loadingService.show();
      // Lógica para confirmar la acción
      console.log("Acción confirmada");
      this.modoEntradaService.eliminarModo(modoEntrada.id).subscribe((data) => {
        console.log("data", data.error);

        if (!data.error) {
          this.cancelarEdicion();
        }

        this.loadingService.hide();
      });
    });

    dialogRef.componentInstance.cancelAction.subscribe(() => {
      // Lógica para cancelar la acción
      console.log("Acción cancelada");
    });
  }

  existeRegistro(control: any, currentValue: any): void {
    existeValorDuplicado(control, this.modoEntradas, currentValue);
  }
}
